import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import useDebugInformation from '../../hooks/useDebugInformation';

const name = "DeleteButtonBR"

type Props = {
    tooltip: string;
    action: () => void;
    parent: string;
    disabledBtn?: boolean
}

const DeleteButtonBR: React.FC<Props> = ({ parent, action, tooltip, disabledBtn }) => {
    const onClick = React.useCallback(() => action(), [action])
    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { onClick, parent, tooltip })
    return (
        <Tooltip title={tooltip ? tooltip : "Delete"}>
            <span>
                <IconButton onClick={onClick} disabled={disabledBtn ? disabledBtn : false}>
                    <DeleteIcon />
                </IconButton>
            </span>
        </Tooltip>
    )
}

export default React.memo(DeleteButtonBR)